import { gql } from '@apollo/client';

const GET_ONE_GROUP = gql`
  fragment OneGroup on Group {
    id
    name
    color
    folderId
    createdAt
    updatedAt
    createdBy {
      id
      email
      firstName
      lastName
      pictureURL
    }
    users {
      id
      auth0Id
      firstName
      lastName
      email
      pictureURL
      activityStatus
      updatedAt
      createdAt
    }
  }

  query GetOneGroup($groupId: ID!) {
    group(id: $groupId) {
      ...OneGroup
    }
  }
`;

export default GET_ONE_GROUP;
